import { Languages } from 'lucide-react';
import { useI18n, type Language } from '@/i18n/i18n';
import { cn } from '@/lib/cn';

const languages: Array<{ value: Language; label: string }> = [
  { value: 'ru', label: 'RU' },
  { value: 'en', label: 'EN' },
];

export function LanguageSwitcher({ className }: { className?: string }) {
  const { language, setLanguage, t } = useI18n();

  return (
    <div
      className={cn(
        'language-switcher',
        className,
      )}
      aria-label={t('language.switch')}
    >
      <Languages className="language-switcher__icon" aria-hidden />
      {languages.map((item) => (
        <button
          key={item.value}
          type="button"
          onClick={() => setLanguage(item.value)}
          className={cn(
            'language-switcher__button',
            language === item.value && 'language-switcher__button--active',
          )}
          aria-pressed={language === item.value}
          title={item.value === 'ru' ? t('language.ru') : t('language.en')}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
